export default "__VITE_ASSET__DV5EcstB__"